import React from 'react';
import PropTypes from 'prop-types';

// Atoms
import { Description, MediumTitle } from '../components/Atoms/Texts';
import { Spacing } from '../components/Atoms/Dividers';
import { BasicWrapper, MaxWidthWrapper } from '../components/Atoms/Wrappers';

const SectionWrapper = (props) => {
	const {
		children, title, description, background,
	} = props;

	return (
		<BasicWrapper background={background} main>
			<MaxWidthWrapper center>
				{title && (
					<>
						<MediumTitle>{title}</MediumTitle>
						<Spacing small />
					</>
				)}
				<Description limit>
					{description}
				</Description>
				{children}
			</MaxWidthWrapper>
		</BasicWrapper>
	);
};

SectionWrapper.defaultProps = {
	title: null,
	description: null,
	background: false,
	children: null,
};

SectionWrapper.propTypes = {
	children: PropTypes.node,
	background: PropTypes.bool,
	title: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.object,
	]),
	description: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.object,
	]),
};

export default SectionWrapper;
